import type { IconProps } from '../types';

export function ListingsIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="m1099.2 30h-998.4c-39.602 0-70.801 32.398-70.801 70.801v997.2c0 39.602 32.398 70.801 70.801 70.801h997.2c39.602 0 70.801-32.398 70.801-70.801v-997.2c1.1992-38.402-31.199-70.801-69.602-70.801zm25.199 1069.2c0 14.398-12 25.199-25.199 25.199h-998.4c-14.398 0-25.199-12-25.199-25.199v-998.4c0-14.398 12-25.199 25.199-25.199h997.2c14.398 0 25.199 12 25.199 25.199v998.4z"
          fill="currentColor"
        />
        <path
          d="m540 170.4h-350.4c-12 0-22.801 10.801-22.801 22.801v814.8c0 12 10.801 22.801 22.801 22.801h350.4c12 0 22.801-10.801 22.801-22.801v-814.8c0-12-9.6016-22.801-22.801-22.801zm-22.801 816h-304.8v-770.4h306c-1.1992 0-1.1992 770.4-1.1992 770.4z"
          fill="currentColor"
        />
        <path
          d="m1010.4 170.4h-352.8c-12 0-22.801 10.801-22.801 22.801v349.2c0 12 10.801 22.801 22.801 22.801h352.8c12 0 22.801-10.801 22.801-22.801l-0.003906-349.2c0-12-10.801-22.801-22.801-22.801zm-22.797 350.4h-307.2v-304.8h307.2z"
          fill="currentColor"
        />
        <path
          d="m1010.4 633.6h-352.8c-12 0-22.801 10.801-22.801 22.801s10.801 22.801 22.801 22.801h352.8c12 0 22.801-10.801 22.801-22.801-0.003906-12.004-10.805-22.801-22.805-22.801z"
          fill="currentColor"
        />
        <path
          d="m1010.4 751.2h-352.8c-12 0-22.801 10.801-22.801 22.801s10.801 22.801 22.801 22.801h352.8c12 0 22.801-10.801 22.801-22.801-0.003906-12-10.805-22.801-22.805-22.801z"
          fill="currentColor"
        />
        <path
          d="m1010.4 868.8h-352.8c-12 0-22.801 10.801-22.801 22.801s10.801 22.801 22.801 22.801h352.8c12 0 22.801-10.801 22.801-22.801-0.003906-13.203-10.805-22.801-22.805-22.801z"
          fill="currentColor"
        />
        <path
          d="m1010.4 986.4h-352.8c-12 0-22.801 10.801-22.801 22.801s10.801 22.801 22.801 22.801h352.8c12 0 22.801-10.801 22.801-22.801-0.003906-13.199-10.805-22.801-22.805-22.801z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
